import { Box, Chip } from "@mui/material"
import type { CellContext, ColumnDef } from "@tanstack/react-table"
import { type ReactElement } from "react"

import { statusesMap } from "../constants"

import { StatusIndicator } from "@/components/common/StatusIndicator/StatusIndicator"
import type { User } from "@/graphql/codegen/graphql"

export const columns: ColumnDef<User>[] = [
  {
    accessorKey: "name",
    header: "User Name",
    id: "name",
    size: 100,
    cell: ({ row }: CellContext<User, unknown>): ReactElement => {
      const { name, isActive } = row.original

      return (
        <Box className='flex items-center justify-start gap-3 px-1'>
          <StatusIndicator status={Boolean(isActive)} map={statusesMap} />
          <div>{name}</div>
        </Box>
      )
    },
  },
  {
    accessorKey: "email",
    header: "Email",
    id: "email",
    size: 150,
    enableSorting: false,
  },
  {
    accessorKey: "roles",
    header: "Roles",
    id: "roles",
    enableSorting: false,
    cell: ({ row: { original } }: CellContext<User, unknown>): ReactElement => {
      const { roles } = original

      return (
        <Box className='flex flex-wrap items-center gap-2'>
          {roles && roles.length > 0 ? (
            roles.map(({ roleId, name }) => <Chip key={roleId} label={name} className='rounded-sm bg-primary-100' />)
          ) : (
            <span className='text-gray-500'>-</span>
          )}
        </Box>
      )
    },
  },
]
